/**
 * Admin bundle — compiled to public/js/admin.js via Laravel Mix.
 * Loaded once, globally, from admin.section.body_links.
 *
 * IMPORTANT: do NOT import Bootstrap here. The legacy admin theme bundle
 * (`public/assets/vendors/core/core.js`) already ships Bootstrap v5.1.3,
 * registers all data-API click handlers, and exposes `window.bootstrap`.
 * Bundling Bootstrap a second time creates two competing `Dropdown` /
 * `Modal` / `Tooltip` classes attached to the same DOM elements — the
 * symptom is dropdowns / tabs that simply do nothing on click, since each
 * library's instance state lives on its own copy of the constructor.
 *
 * This file's only job is to initialise Orbio-specific tooltips that
 * have to be constructed per-element (Bootstrap doesn't auto-init those).
 */

function initOrbioTooltips() {
    if (!window.bootstrap || typeof window.bootstrap.Tooltip !== 'function') {
        return;
    }
    document.querySelectorAll('.orbio-page [data-bs-toggle="tooltip"]').forEach(function (el) {
        try {
            // Skip if already initialised by another path
            if (window.bootstrap.Tooltip.getInstance(el)) return;
            new window.bootstrap.Tooltip(el, { customClass: 'od-tooltip' });
        } catch (e) {
            /* swallow — not fatal */
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrbioTooltips);
} else {
    initOrbioTooltips();
}
